import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class DealService {

  constructor(private api: ApiService) { }

  getAllDeal(data:any): Observable<any> {
    return this.api.post(environment.getAllDeal,data);
  }

  updateDeal(data:any): Observable<any> {
    return this.api.post(environment.updateDeal,data);
  }

  createDeal(data:any): Observable<any> {
    return this.api.post(environment.createDeal,data);
  }
  
  deleteDeal(data:any): Observable<any> {
    return this.api.post(environment.deleteDeal,data);
  }

  getDealsAnalytics(data:any): Observable<any> {
    return this.api.post(environment.getDealsAnalytics,data);
  }
}

